import { defineStore } from 'pinia';
import { ref, computed, watch } from 'vue';
import { Notify } from 'quasar'
import api from '../services/api';
import { useFormsStore } from "stores/forms";
import { useWorkspacesStore } from "stores/workspaces";

export const useStudioStore = defineStore('studio', () => {
  const formsStore = useFormsStore();
  const workspacesStore = useWorkspacesStore();
  const activeFormId = computed(() => formsStore.active?.id)
  const activeWorkspaceId = computed(() => workspacesStore.active.id)
  const formSchemaLoaded = ref(false)
  // Raw form definition string
  const formSchema = ref(null)
  watch(() => activeFormId, () => {
    formSchema.value = null
    formSchemaLoaded.value = false
  });

  function setSchema(value) {
    formSchema.value = value
    formSchemaLoaded.value = true
  }

  async function loadSchema () {
    try {
      formSchema.value = (await api.getFormSchema(activeWorkspaceId.value, activeFormId.value)).schema
    } catch(error) {
      formSchema.value = null
    }
    formSchemaLoaded.value = true
  }

  function $reset() {
    formSchema.value = null
    formSchemaLoaded.value = false
    // publishFormStorageKey.value = null // we do not reset this on purpose, so it will survive login
  }


  const publishFormStorageKey = ref(null)
  function setPublishFormStorageKey(newKey) {
    publishFormStorageKey.value = newKey
  }
  const publishFormNotification = ref(null)
  function closePublishFormNotification () {
    if (publishFormNotification.value) {
      publishFormNotification.value()
    }
  }
  function updatePublishFormNotification(notificationProps) {
    if (publishFormNotification.value) {
      publishFormNotification.value(notificationProps)
    } else {
      publishFormNotification.value = Notify.create({
        color: 'pink',
        timeout: 0,
        position: 'bottom',
        html: true,
        multiLine: true,
        group: false,
        ...notificationProps
      })
    }
  }
  return {
    $reset,
    loadSchema,
    formSchema,
    formSchemaLoaded,
    setSchema,
    publishFormStorageKey,
    setPublishFormStorageKey,
    updatePublishFormNotification,
    closePublishFormNotification
  }
})

